import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Provider } from "./store.js";
import { Container } from "./Container.js";
import { Block } from "./Block.js";
import { Textarea } from "./Textarea.js";
import { Select } from "./Select.js";
import { Input } from "./Input.js";
import { Button } from "./Button.js";
import { jsx as _jsx } from "react/jsx-runtime";
export * from "./Input.js";
export * from "./Textarea.js";
export * from "./Select.js";
export * from "./Block.js";
export * from "./Button.js";
export * from "./Container.js";
export * from "./Render.js";
export * from "./store.js";
var Login = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Provider, {
    children: /*#__PURE__*/_jsx(Container, _extends({}, props, {
      ref: ref
    }))
  });
});
Login.Block = Block;
Login.Button = Button;
Login.Input = Input;
Login.Textarea = Textarea;
Login.Select = Select;
Login.displayName = 'Login';
export default Login;